module.exports = __webpack_public_path__ + "static/img/JM45.4a4f2c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-2/JM45.png
// module id = 66qf
// module chunks = 12